<template>
  <InfoPage>
    <h1 class="display-1 mt-2 mt-md-6 mt-lg-12 mb-6">{{ $t("erreur.collecte.titre") }}</h1>
    <p>{{ $t("erreur.collecte.description") }}</p>
    <p>{{ $t("erreur.collecte.telephone") }}</p>
  </InfoPage>
</template>

<script>
import InfoPage from "@/layouts/InfoPage"

export default {
  components: {
    InfoPage
  }
}
</script>

<style>
</style>